import get from 'lodash/get';
import {
  FOLDER_CREATED,
  FOLDER_DELETED,
  FOLDER_RENAMED,
  FOLDERS_SET,
  FOLDER_ANNOTATION_CHANGED,
  FOLDER_DECISION_DELETED,
  FOLDER_GET_DECISIONS,
  FOLDER_LOAD_DECISIONS,
  FOLDER_ERROR_DECISIONS,
  FOLDER_LOAD_ANNOTATIONS,
  FOLDER_ERROR_ANNOTATIONS,
  FOLDER_GET_ANNOTATIONS,
} from '../action-types';
import { FoldersReducerType } from '../foldersState.types';
import { FolderActions } from '../actions';
import { FolderDecision } from '../../page/folders.types';
import {
  loadDecisionsState,
  errorDecisionsState,
  getDecisionsState,
  loadAnnotationsState,
  errorAnnotationsState,
  getAnnotationsState,
} from './foldersStateFunctions';

const initialState: FoldersReducerType = {
  folders: {},
  decisionsCountByFolder: {},
  foldersLoaded: false,
  orderChrono: [],
  orderByName: [],
};

export function foldersReducer(
  state: FoldersReducerType = initialState,
  action: FolderActions,
) {
  switch (action.type) {
    case FOLDERS_SET: {
      const { folders, orderByName, decisionsCountByFolder } = action.payload;
      const newFolders = { ...state.folders, ...folders };
      return {
        ...state,
        folders: newFolders,
        decisionsCountByFolder,
        foldersLoaded: true,
        orderChrono: Object.keys(newFolders),
        orderByName,
      };
    }
    case FOLDER_CREATED: {
      const { folder } = action.payload;
      return {
        ...state,
        folders: {
          ...state.folders,
          [folder.folderKey]: {
            ...folder,
            numberOfDecision: 0,
            folderAnnotation: '',
          },
        },
        decisionsCountByFolder: {
          ...state.decisionsCountByFolder,
          [folder.folderKey]: 0,
        },
        orderChrono: [folder.folderKey].concat(state.orderChrono),
        orderByName: [folder.folderKey].concat(state.orderByName),
      };
    }
    case FOLDER_RENAMED: {
      const { title, folderKey } = action.payload;
      return {
        ...state,
        folders: {
          ...state.folders,
          [folderKey]: { ...state.folders[folderKey], title },
        },
      };
    }
    case FOLDER_DELETED: {
      const { folderKey } = action.payload;
      const newFolders = { ...state.folders };
      delete newFolders[folderKey];
      const newOrderChrono = state.orderChrono.filter(key => key !== folderKey);
      const newOrderByName = state.orderByName.filter(key => key !== folderKey);
      return {
        ...state,
        folders: newFolders,
        orderChrono: newOrderChrono,
        orderByName: newOrderByName,
      };
    }

    case FOLDER_DECISION_DELETED: {
      const { folderKey, docId } = action.payload;
      const currentDecisions = get(
        state.folders[folderKey],
        ['decisions', 'decisions'],
        [],
      );
      const currentIndex = get(
        state.folders[folderKey],
        ['decisions', 'currentIndex'],
        0,
      );

      return {
        ...state,
        folders: {
          ...state.folders,
          [folderKey]: {
            ...state.folders[folderKey],
            decisions: {
              ...state.folders[folderKey].decisions,
              decisions: currentDecisions.filter(
                (decision: FolderDecision) => decision.docId !== docId,
              ),
              currentIndex: currentIndex - 1,
            },
          },
        },
        decisionsCountByFolder: {
          ...state.decisionsCountByFolder,
          [folderKey]:
            state.decisionsCountByFolder[folderKey] > 0
              ? state.decisionsCountByFolder[folderKey] - 1
              : 0,
        },
      };
    }

    case FOLDER_ANNOTATION_CHANGED: {
      const { folderAnnotation, folderKey } = action.payload;
      return {
        ...state,
        folders: {
          ...state.folders,
          [folderKey]: { ...state.folders[folderKey], folderAnnotation },
        },
      };
    }

    case FOLDER_LOAD_DECISIONS: {
      const { folderKey } = action.payload;
      return loadDecisionsState(state, folderKey);
    }

    case FOLDER_ERROR_DECISIONS: {
      const { error, folderKey } = action.payload;
      return errorDecisionsState(state, folderKey, error);
    }

    case FOLDER_GET_DECISIONS: {
      const { folderKey, decisions, size } = action.payload;
      return getDecisionsState(state, folderKey, decisions, size);
    }

    case FOLDER_LOAD_ANNOTATIONS: {
      const { folderKey } = action.payload;
      return loadAnnotationsState(state, folderKey);
    }

    case FOLDER_ERROR_ANNOTATIONS: {
      const { error, folderKey } = action.payload;
      return errorAnnotationsState(state, folderKey, error);
    }

    case FOLDER_GET_ANNOTATIONS: {
      const { folderKey, annotations } = action.payload;
      return getAnnotationsState(state, folderKey, annotations);
    }

    default:
      return state;
  }
}
